"use strict";

var _index = _interopRequireDefault(require("./index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onRouteUpdate = function (_ref, pluginOptions) {
  var location = _ref.location;

  if (pluginOptions.trackPageViews) {
    var ignore = pluginOptions.ignorePages || [];
    var pathname = location.pathname;
    var page = pathname.replace(/\//g, '') || 'home';

    if (!ignore.includes(page)) {
      var event = `view-${page}`;
      (0, _index.default)(event);
    }
  }
};